import { get, has, isEmpty } from 'lodash'
import { createSelector } from 'reselect'

const getIsLoggedIn = state => state.isLoggedIn

const getHasConsumerAccount = state =>
  get(state, 'application') && (isEmpty(state.application) || state.application.hasConsumerAccount)

const getApplicantEmail = state =>
  has(state, 'application.email') ? state.application.email : false

const getConsumerEmail = state => state.consumerEmail

const getIsSubmittingProfile = state => state.isSubmittingProfile

export const requiresLoginSelector = createSelector(
  getIsLoggedIn,
  getHasConsumerAccount,
  getApplicantEmail,
  getConsumerEmail,
  getIsSubmittingProfile,
  (
    isLoggedIn,
    hasConsumerAccount,
    applicantEmail,
    consumerEmail,
    isSubmittingProfile
  ) => {
    /**
     * Login is not needed unless
     * 1. profile is submitted
     * 2. consumer account is created
     * 3. user is logged out OR user token doesnt
     * match applicant email
     */
    return Boolean(
      !isSubmittingProfile &&
      hasConsumerAccount &&
      ((applicantEmail !== consumerEmail) || !isLoggedIn)
    )
  }
)
